import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import React from 'react';
import { range } from 'ramda';
import Icon from '../Icon';
import NumberWrapper from './NumberWrapper';
import CounterWrapper from './CounterWrapper';
import StyledIconButton from './StyledIconButton';
/**
 * 获取页码
 * @param {number} currentPage
 * @param {number} totalPage
 */
export function getPageItems(currentPage, totalPage) {
    if (totalPage <= 5) {
        return range(1, totalPage + 1);
    }
    if (currentPage <= 3) {
        return range(1, 6);
    }
    if (currentPage >= totalPage - 2) {
        return range(totalPage - 4, totalPage + 1);
    }
    return range(currentPage - 2, currentPage + 3);
}
function Counter(props) {
    return (React.createElement(CounterWrapper, null,
        React.createElement(StyledIconButton, { disabled: props.currentPage === 1, dense: true, onClick: function () {
                return props.onPageNumberChange &&
                    props.onPageNumberChange(props.currentPage - 1);
            } },
            React.createElement(Icon, { disabled: props.currentPage === 1 },
                React.createElement(MdChevronLeft, null))),
        getPageItems(props.currentPage, props.totalPage).map(function (page) { return (React.createElement(NumberWrapper, { selected: page === props.currentPage, onClick: function () {
                return props.onPageNumberChange && props.onPageNumberChange(page);
            }, key: page }, page)); }),
        React.createElement(StyledIconButton, { disabled: props.currentPage === props.totalPage || props.totalPage === 0, dense: true, onClick: function () {
                return props.onPageNumberChange &&
                    props.onPageNumberChange(props.currentPage + 1);
            } },
            React.createElement(Icon, { disabled: props.currentPage === props.totalPage || props.totalPage === 0 },
                React.createElement(MdChevronRight, null)))));
}
export default Counter;
//# sourceMappingURL=Counter.js.map